export const _SitemapOrcamentos = {
    url: 'orcamento',
    descricao: 'Orçamentos',
    nome: 'Orçamentos',
    permissao: ['VisualizarOrcamentos'],
    fullUrl: '/orcamento/menu',
    children:
        {
            ['menu']: {
                url: 'menu',
                descricao: 'Menu de orçamentos',
                nome: 'Menu de orçamentos',
                permissao: ['VisualizarOrcamentos'],
                fullUrl: '/orcamento/menu',
            },
            ['lista']: {
                url: 'lista',
                descricao: 'Lista de orçamentos',
                nome: 'Lista de orçamentos',
                permissao: ['VisualizarOrcamentos'],
                fullUrl: '/orcamento/lista',
            },
            ['a_pagar']: {
                url: 'a-pagar',
                descricao: 'Lista de orçamentos pendente de pagamento',
                nome: 'Orçamentos a pagar',
                permissao: ['VisualizarOrcamentos'],
                fullUrl: '/orcamento/a-pagar',

            },
            ['detalhes']: {
                url: 'detalhes',
                descricao: 'Detalhes do orçamento',
                nome: 'Detalhes do orçamento',
                permissao: ['VisualizarOrcamentos'],
                fullUrl: '/orcamento/detalhes',
            },
            ['flags']: {
                url: 'flags',
                descricao: 'Sinalizações de orçamento',
                nome: 'Sinalizações de orçamento',
                permissao: ['VisualizarOrcamentos'],
                fullUrl: '/orcamento/flags',
            }
        },
} as const